import { Component, ViewChild } from '@angular/core';
import { IComboSelectionChangingEventArgs, IDropDroppedEventArgs, ISelectionEventArgs, IgxComboComponent, IgxSelectComponent } from '@infragistics/igniteui-angular';
import { Group } from 'src/app/models/group';
import { Kid } from 'src/app/models/kid';
import { Level } from 'src/app/models/level';
import { Package } from 'src/app/models/package';
import { Participant } from 'src/app/models/participant';
import { Period } from 'src/app/models/period';
import { User } from 'src/app/models/user';
import { MessagesService } from 'src/app/services/messages.service';

@Component({
    selector: 'app-group',
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.scss']
})
export class GroupComponent {
    @ViewChild('teachersCombo', {static: true, read: IgxComboComponent})
    private teachersCombo!: IgxComboComponent;

    private _allGroups: Group[] = [];
    private _participants: Participant[] = [];
    private _periods: Period[] = [];
    private _packages: Package[] = [];

    public date: Date | undefined;
    public kids: Kid[] = [];
    public teachers: User[] = [];
    public participants: Kid[] = [];
    public levels: Level[] = [];
    public groups: Group[] = [];
    public selectedTeachers: User[] = [];

    constructor(
        private msgs: MessagesService,
    ) {
    }

    public dateChange = async (e: Date): Promise<void> => {
        this._participants = [];
        this.date = e;
        if (this._packages.length === 0) {
            // this._packages = init packages
        }
        if (this._periods.length === 0) {
            // this._periods = init periods
        }
        this.participants = this.kids.filter(k => k.packages
            .map(p => this._packages.find(_p => _p.id === p.id))
            .filter((p): p is Package => !!p)
            .map(p => this._periods.find(_p => _p.id === p.period.id))
            .filter((p): p is Period => !!p)
            .some(p => p.dates.some(d => d.getTime() === this.date?.getTime())));
        this.groups = this._allGroups.filter(tg => tg.date.getTime() === e?.getTime());
        for (const group of this.groups) {
            // refresh group
            for (const participant of group.participants) {
                if (!participant.kid?.id) {
                    // refresh participants
                }
            }
        }
        this.groups = this.groups.filter(g => g.participants.length > 0);
        if (this.teachers.length < 1) {
            // this.teachers = init teachers
        }
        const selectedTeachers = this.teachers
            .filter(t => this.groups.find(g => g.teacher.id === t.id));
        this.teachersCombo?.select(selectedTeachers.map(t => t.id), true);
        this.groups.forEach(g => g.participants.forEach(p => {
            this.participants = this.participants.filter(k => k.id !== p.kid.id);
            this._participants.push(p);
        }));
    }

    public teachersChange = (e: IComboSelectionChangingEventArgs): void => {
        this.selectedTeachers = [];
        e.newValue.forEach(t => {
            var teacher = this.teachers.find(x => x.id === t)!;
            this.selectedTeachers.push(teacher);
            if (this.groups.find(g => g.teacher.id === t))
                return;

            // let group = this._allGroups.find(g => g.date.getTime() === this.date?.getTime() && g.teacher.id === t);
            // if (!group) {
            //     group = new Group();
            //     group.date = this.date!;
            //     group.teacher = teacher;
            //     group.participants = [];
            // }

            // this.groups.push(group);
        });
        e.removed.forEach(async t => {
            const group = this.groups.find(g => g.teacher.id === t);
            if (group) {
                const participants = [...group.participants];
                participants.forEach(p => this._removeParticipantInternal(p!.kid.id!, group));
                this.groups = this.groups.filter(g => g.teacher.id !== group.teacher.id);
            }
        });
    }

    public save = async () => {
        try {
            
            // await Promise.all(this.groups.map(async g => {
            //     const participants = g.participants;
            //     g.participants = await Promise.all(participants.map(async raw => {
            //         let p = this._participants.find(v => v.id === raw.id) ?? new Participant();
            //         p = raw;
            //         p.group = g;
            //         return p;
            //     }));
            //     if (!this._allGroups.find(tg => tg.id === g.id)) {
            //         this._allGroups.push(g);
            //     }
            //     g.participants ??= [];
            // }));
            this.msgs.success(`Разпределението е записано успешно.`);
        }
        catch (err) {
            this.msgs.error(err);
        };
    }

    public moveAllKidsToTeacher = (e: ISelectionEventArgs, select: IgxSelectComponent): void => {
        const group = this.groups.find(g => g.teacher.id === e.newSelection.value.id);
        this.participants
            .map(p => p.id)
            .forEach(k => this._addParticipantInternal(k!, group!));
        e.cancel = true;
        select.close();
    }

    public teacherName = (teacherId?: string): string => {
        const teacher = this.teachers.find(t => t.id === teacherId);
        if (teacher) {
            return `${teacher.firstName} ${teacher.lastName}`;
        }
        return '';
    }

    public addToGroup = (e: IDropDroppedEventArgs, group: Group) => {
        this._addParticipantInternal(e.dragData.chip.id, group);
    }

    public removeKidFromGroup = (kid: Kid, group: Group) => {
        this._removeParticipantInternal(kid.id!, group);
    }

    public kidOnGroup = (group: Group): Kid[] => {
        const result = group.participants
            .map(p => this.kids.find(k => k.id === p?.kid?.id))
            .filter((k): k is Kid => !!k);
        return result;
    }

    private _addParticipantInternal = (kidId: string, group: Group): void => {
        const kid = this.kids.find(k => k.id === kidId);
        if (!kid || !this.date)
            return;

        let participant = this._participants.find(p => p!.kid.id === kidId);

        const oldGroup = this.groups.find(g => g.participants.some(p => p?.kid.id === kidId));
        if (oldGroup) {
            this._removeParticipantInternal(kidId, oldGroup);
        }

        if (!participant) {
            participant = {
                date: this.date,
                kid: kid,
                group: group
            }
            this._participants.push(participant);
        }
        group.participants.push(participant);
        const participantIndex = this.participants.findIndex(p => p.id === kidId);
        if (participantIndex !== -1)
            this.participants.splice(participantIndex, 1);
    }

    private _removeParticipantInternal = (kidId: string, group: Group): void => {
        const passengerIndex = group.participants.findIndex(p => p.kid.id === kidId);
        if (passengerIndex < 0)
            return;

        group.participants.splice(passengerIndex, 1);
        const kid = this.kids.find(k => k.id === kidId);
        if (!kid)
            return;

        this.participants.push(kid);
    }
}
